import React from "react"

export default function ProductDetail({
    product
}) {
    const {images, iframePath} = product;

    return (
        <div>
            {
                iframePath &&
                <iframe 
                    title="NaverVideo" 
                    width="544" 
                    height="306" 
                    style={{
                        display: 'block',
                        maxWidth: '100%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }} 
                    src={iframePath} 
                    frameborder="no" 
                    scrolling="no" 
                    allow="autoplay; gyroscope; accelerometer; encrypted-media" 
                    allowfullscreen/>
            }
            {
                images &&
                images.map((imgPath, index) => {
                    return (
                        <img
                            key={index}
                            src={require(`../assets/${imgPath}`)}
                            alt={index}
                            style={{
                                maxWidth: '100%',
                                height: 'auto',
                                display: 'block',
                                marginLeft: 'auto',
                                marginRight: 'auto' 
                            }}
                        />
                    )
                })    
            }            
        </div>
    )
}